import { render, staticRenderFns } from "./Practitioner.vue?vue&type=template&id=1aa4f668&scoped=true"
import script from "./Practitioner.vue?vue&type=script&lang=js"
export * from "./Practitioner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4f668",
  null
  
)

export default component.exports